




















import { Vue, Component, Prop } from 'vue-property-decorator'
import { PalletPattern, Settings } from '@/model/index'
import { mapGetters } from 'vuex'
import { Pages } from '@/pages'
import PalletPatternDetails from '@/components/PalletPatternDetails'
import NavButton from '@/components/shared/NavButton'
import Units from '@/api/utils/units'

@Component({
  components: {
    PalletPatternDetails: PalletPatternDetails,
    NavButton: NavButton,
  },
  computed: {
    ...mapGetters('palletpatterns', [
      'isLoading',
      'isLoaded',
      'selectedEntity'
    ]),
    ...mapGetters('settings', ['settings'])
  }
})
export default class Details extends Vue {
  private viewRouteLink: any = Pages.VIEWPALLETPATTERNS.routeLink
  private selectedEntity!: PalletPattern
  private settings!: Settings

/*
  get collectionById () {
    return this.$store.getters['patternimages/collectionById'](this.selectedEntity.guid)
  }
*/

  get units () {
    return new Units(this.settings.units || Settings.UnitsEnum.METRIC)
  }

}
